<template>
  <div class="v-card-group">
    <h4 class="v-card-group-title">
      <slot name="title" />
      {{ title }}
    </h4>
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseCard",
  props: {
    title: {
      type: String,
      default: "",
      required: false
    }
  }
};
</script>
